module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "lan"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "30",
      "src": "images/eer-kaiulani-ornament.jpg",
      "width": "61"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerkaiulani0008#rlan"
    }
  }, [_vm._v("A Word about the Hawaiian Language")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("If you’ve ever heard Hawaiian, you know that it’s a dramatic and expressive language. The language is meant to be spoken; in fact, no written version existed until the missionaries arrived in the islands less than two hundred years ago.")]), _vm._v(" "), _c('p', [_vm._v("The entire Hawaiian alphabet consists of only twelve letters: the English vowels "), _c('em', [_vm._v("a, e, i, o,")]), _vm._v(" and "), _c('em', [_vm._v("u;")]), _vm._v(" and seven consonants, "), _c('em', [_vm._v("h, k, l, m, n, p,")]), _vm._v(" and "), _c('em', [_vm._v("w")]), _vm._v(". Here is a very simplified guide to pronunciation.")]), _vm._v(" "), _c('p', [_vm._v("The consonants retain their American sounds.")]), _vm._v(" "), _c('p', [_vm._v("The vowels are generally pronounced as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "ulf"
  }, [_vm._v("a   is "), _c('em', [_vm._v("uh")]), _vm._v(" (as in amount)")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ā")]), _vm._v("   is "), _c('em', [_vm._v("ah")]), _vm._v(" (as in ha)")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("e   is "), _c('em', [_vm._v("eh")]), _vm._v(" (as in led)")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ē")]), _vm._v("   is "), _c('em', [_vm._v("ay")]), _vm._v(" (as in hey)")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("i   is "), _c('em', [_vm._v("ee")]), _vm._v(" (as in piece)")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("o   is "), _c('em', [_vm._v("oh")]), _vm._v(" (as in oboe)")]), _vm._v(" "), _c('p', {
    staticClass: "ull"
  }, [_vm._v("u   is "), _c('em', [_vm._v("oo")]), _vm._v(" (as in blue)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("When you see a macron (¯) over a vowel, it not only changes the sound; it alerts you to give the vowel a little more emphasis, to draw it out a bit.")]), _vm._v(" "), _c('p', [_vm._v("Also important is the glottal stop, which looks like an inverted comma (‘). The glottal stop cues you to do just that — stop briefly in the middle of the word, then keep going. It’s much like the English “uh-oh.”")]), _vm._v(" "), _c('p', [_vm._v("In Hawaiian, unlike English, there are no tricky instances where vowels or consonants run together, although sometimes two vowels will be said quickly together, almost like an English diphthong. For example, the word "), _c('em', [_vm._v("poi")]), _vm._v(" is usually spoken as one syllable, though each vowel briefly gets its own sound.")]), _vm._v(" "), _c('p', [_vm._v("Four basic rules will take you far in pronouncing Hawaiian:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nlf"
  }, [_vm._v("1. Each letter gets a sound.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("2. There is never more than one consonant per syllable.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("3. Every syllable ends with a vowel. So it’s easy to sound out “Honolulu”: Ho-no-lu-lu. If you can do that, you can do it with longer, harder-looking words, like Ka-w"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ā")]), _vm._v("-na-na-ko-a.")]), _vm._v(" "), _c('p', {
    staticClass: "nll"
  }, [_vm._v("4. The final rule of thumb is that words are accented on their "), _c('em', [_vm._v("second-to-last syllable.")]), _vm._v(" So: Ka-i-u-LA-ni. (Kah-ee-oo-LAnee). Words with only two syllables are accented on the first syllable. So: LE-i (LAY-ee).")])]), _vm._v(" "), _c('p', [_vm._v("A final interesting note is that during the time period which this book discusses, Hawaiians often found it in their best interests to seem Westernized. Consequently, they seldom used correct Hawaiian punctuation while writing, leaving out glottal stops and macrons. During her life, Princess Ka‘iulani spelled her name simply “Kaiulani” and let it be pronounced in the Anglicized way: Kaye-oo-LA-nee.")]), _vm._v(" "), _c('p', [_vm._v("In recent times, as native Hawaiian pride and culture have flourished once again, the written language has been restored, treated with proper respect, and so it is again punctuated correctly — which also gives foreigners a much easier guide to pronunciation!")]), _vm._v(" "), _c('p', [_vm._v("Here are pronunciations of some of the Hawaiian words used in this book:")]), _vm._v(" "), _c('div', {
    staticClass: "glossary"
  }, [_c('p', {
    staticClass: "glof"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_c('span', {
    staticClass: "dcrit"
  }, [_vm._v("Ā")]), _vm._v("inahau")]), _vm._v(" ("), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ā")]), _vm._v("y-NA-how)")]), _vm._v(": “Land of Cool Breezes,” the name of Ka‘iulani’s Waik"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ī")]), _vm._v("k"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ī")]), _vm._v(" estate")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("ali‘i")]), _vm._v(" (uh-LEE-ee)")]), _vm._v(": chief; the highest nobility (Like other nouns in the Hawaiian language, the plural form does not take an “s.”)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("aloha")]), _vm._v(" (ah-LOW-ha)")]), _vm._v(": “love”; a wish spoken both in greeting and in parting")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("anaana")]), _vm._v(" (ah-na-AH-na)")]), _vm._v(": the ancient pray-to-death ritual")]), _vm._v(" "), _c('p', {
    staticClass: "glof"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("haole")]), _vm._v(" (HOW-lee)")]), _vm._v(": a Caucasian foreigner; the term is slightly derogatory")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("holok"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ū")])]), _vm._v(" (ho-LO-ko"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ō")]), _vm._v(")")]), _vm._v(": a long Hawaiian dress with a yoke and a train; it can be made to be casual or very dressy")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("Huna")]), _vm._v(" (HOO-nah)")]), _vm._v(": the ancient Hawaiian religion; literally “The Secret”")]), _vm._v(" "), _c('p', {
    staticClass: "glof"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("‘Iolani")]), _vm._v(" (ee-o-LAH-nee)")]), _vm._v(": “The Hawk of Heaven,” the name of the royal palace")]), _vm._v(" "), _c('p', {
    staticClass: "glof"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("k"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ā")]), _vm._v("hili")]), _vm._v(" (k"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ū")]), _vm._v("h-HEE-lee)")]), _vm._v(": large sticks decorated with colorful feathers, symbols of Hawaiian royalty")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("kahuna")]), _vm._v(" (ka-HOO-nah)")]), _vm._v(": a scholar or priest")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("Ka‘iulani")]), _vm._v(" (ka-ee-oo-LAH-nee)")]), _vm._v(": the last crown princess of Hawai‘i")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("Kal"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ā")]), _vm._v("kaua")]), _vm._v(" (ka-lah-KOW-ah)")]), _vm._v(": the last king of Hawai‘i")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("Kamehameha")]), _vm._v(" (ka-MAY-ha-MAY-ha)")]), _vm._v(": the great warrior who united the islands; the dynasty he founded is named after him")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("kanaka")]), _vm._v(" (ka-NAH-ka)")]), _vm._v(": a person (typically used to refer to a commoner, someone not of the ali‘i class)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("Kapi‘olani")]), _vm._v(" (kah-pee-o-LAH-nee)")]), _vm._v(": Kal"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ā")]), _vm._v("kaua’s queen")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("kapu")]), _vm._v(" (KA-poo)")]), _vm._v(": forbidden, sacred — also used to describe the laws that defined the sacred or forbidden")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("keiki")]), _vm._v(" (KEHee-kee)")]), _vm._v(": child")]), _vm._v(" "), _c('p', {
    staticClass: "glof"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("l"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ā")]), _vm._v("nai")]), _vm._v(" (lah-NA-ee, or la-NYE)")]), _vm._v(": an open-air living space; a veranda")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("lei")]), _vm._v(" (LAY-ee)")]), _vm._v(": a wreath of flowers")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("Likelike")]), _vm._v(" (lee-kay-LEE-kay)")]), _vm._v(": Ka‘iulani’s mother")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("Lili‘uokalani")]), _vm._v(" (lee-lee-u-oh-kah-LAH-nee)")]), _vm._v(": Hawai‘i’s last queen")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("l"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ū")]), _vm._v("au")]), _vm._v(" (loo-AHoo)")]), _vm._v(": a great feast")]), _vm._v(" "), _c('p', {
    staticClass: "glof"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("m"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ō")]), _vm._v("‘"), _c('span', {
    staticClass: "dcrit"
  }, [_vm._v("ī")])]), _vm._v(" (MOH-EE)")]), _vm._v(": the king")]), _vm._v(" "), _c('p', {
    staticClass: "glof"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("nei")]), _vm._v(" (NAYee)")]), _vm._v(": this very place")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("nui")]), _vm._v(" (NOOee)")]), _vm._v(": big, large, grand")]), _vm._v(" "), _c('p', {
    staticClass: "glof"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("paniolo")]), _vm._v(" (pah-nee-O-low)")]), _vm._v(": cowboy")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('strong', [_vm._v("poi")]), _vm._v(" (POHee)")]), _vm._v(": a white paste made from mashed taro, a native plant")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dff0ad0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-kaiulani-0010.vue
// module id = 81
// module chunks = 0